import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconThumbsDown24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.93 14.036a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3h-1v10zm-2.5 1.109V4.036H8.205a3 3 0 0 0-2.628 1.555l-2.2 4c-1.1 1.999.347 4.445 2.628 4.445h3.427l-.533 4.274c-.18 1.456 1.62 2.28 2.603 1.19z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown24Filled);
